import ErrorState from '../containers/ErrorState/ErrorState';

export const ErrorRoutes = [
	{
		...ErrorState,
		path: '/error/:type',
		exact: true,
		titleId: 'app.document.title',
	},
	{
		...ErrorState,
		path: '*',
		exact: true,
		titleId: 'app.document.title',
	},
];
